import {createReducer, PayloadAction} from "@reduxjs/toolkit";
import * as actions from "./actions";

export const INITIAL_STATE: { catRevue: any[] | null } = {
    catRevue: null,
};

const reducer = createReducer(INITIAL_STATE, (builder) => {
    builder
        .addCase(actions.catRevue, (state, action) => {
            state.catRevue = action.payload;
        })
});

export default reducer;
